import { css, extractTransition, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';
import { MessageInfoStyleProps, MessageInfoVariant } from './MessageInfo.types';

const styles = {
  root: ({ theme, props: { variant } }) => css`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    flex-shrink: 0;
    gap: 12px;
    padding: 12px 16px;

    border-radius: 8px;

    ${variant === MessageInfoVariant.Default &&
    css`
      color: ${theme.colors.secondary.sky[60]};
      background-color: ${theme.colors.secondary.sky[10]};
    `}

    ${variant === MessageInfoVariant.Success &&
    css`
      color: ${theme.colors.secondary.emerald[60]};
      background-color: ${theme.colors.secondary.emerald[10]};
    `}

    ${variant === MessageInfoVariant.Ai &&
    css`
      color: ${theme.colors.primary.fuchsia[60]};
      background-color: ${theme.colors.primary.fuchsia[10]};
    `}

    ${variant === MessageInfoVariant.Danger &&
    css`
      color: ${theme.colors.tertiary.red[60]};
      background-color: ${theme.colors.tertiary.red[10]};
    `}
  `,
  icon: ({ theme, props: { variant } }) => css`
    display: flex;
    flex-shrink: 0;
    padding: 4px;

    border-radius: 50%;

    ${variant === MessageInfoVariant.Default &&
    css`
      background-color: ${theme.colors.secondary.sky[20]};
    `}

    ${variant === MessageInfoVariant.Success &&
    css`
      background-color: ${theme.colors.secondary.emerald[20]};
    `}

    ${variant === MessageInfoVariant.Ai &&
    css`
      background-color: ${theme.colors.primary.fuchsia[20]};
    `}

    ${variant === MessageInfoVariant.Danger &&
    css`
      background-color: ${theme.colors.tertiary.red[20]};
    `}
  `,
  message: css`
    display: flex;
    align-items: center;
    min-height: 22px;
    width: 100%;
  `,
  close: ({ theme, props: { variant } }) => css`
    display: flex;
    cursor: pointer;
    border-radius: 50%;
    user-select: none;

    ${extractTransition((f) => f.cubic, { property: ['background-color', 'box-shadow'], duration: 240 })}

    &:hover {
      ${variant === MessageInfoVariant.Default &&
      css`
        background-color: ${theme.colors.secondary.sky[20]};
        box-shadow: 0px 0px 0px 4px ${theme.colors.secondary.sky[20]};
      `}

      ${variant === MessageInfoVariant.Success &&
      css`
        background-color: ${theme.colors.secondary.emerald[20]};
        box-shadow: 0px 0px 0px 4px ${theme.colors.secondary.emerald[20]};
      `}

      ${variant === MessageInfoVariant.Ai &&
      css`
        background-color: ${theme.colors.primary.fuchsia[20]};
        box-shadow: 0px 0px 0px 4px ${theme.colors.primary.fuchsia[20]};
      `}

      ${variant === MessageInfoVariant.Danger &&
      css`
        background-color: ${theme.colors.tertiary.red[20]};
        box-shadow: 0px 0px 0px 4px ${theme.colors.tertiary.red[20]};
      `}
    }
  `,
} satisfies Styles<MessageInfoStyleProps>;

export const useStyles = withStyles(styles);
